import script from "./InvestFormTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestFormTotals.vue?vue&type=script&setup=true&lang=ts"

import "./InvestFormTotals.vue?vue&type=style&index=0&id=26e898d2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e898d2"]])

export default __exports__